import React from 'react';
import { ThemeProps } from '../../../types';
import styled from '@emotion/styled';
import { useEffect, useRef, useState } from "react";
import { getCookieConsent, setCookieConsent } from "../../../utils/domainCookie";
import { Mixpanel } from 'mixpanel-browser';

export interface CCProps {
  localeCopy: any,
  fallbackCopy: any,
  mixpanel: Mixpanel,
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
}

const CookieConsent = ({ localeCopy, fallbackCopy, mixpanel, className }: CCProps) => {
  const [showCC, setShowCC] = useState(false);

  const ccCheck = useRef(false);

  useEffect(() => {
    function checkCookieConsent(){
      const ccCookie = getCookieConsent();
  
      if(ccCookie === undefined) {
        setShowCC(true);
      }
      else if(ccCookie === true){
        mixpanel.opt_in_tracking();
      }
    }
    
    if(!ccCheck.current)
    {
      ccCheck.current = true;

      checkCookieConsent();
    }
  }, [mixpanel]);



  function handleCookieConsent(optionalConsent: boolean){
    if(optionalConsent === true) {
      mixpanel.opt_in_tracking();
    }
    setCookieConsent(optionalConsent);
    setShowCC(false);
  }

  if(!showCC) {
    return <></>
  }
  else {
    return (
      <div className={className}>
        <span className="consentDesc">{
          localeCopy?.components?.cookieConsent?.consentDesc ||
          fallbackCopy.components.cookieConsent.consentDesc }
        </span>
        <div className="buttonContainer">
          <button className="baseButton" onClick={()=>handleCookieConsent(true)}>
            {localeCopy?.components?.cookieConsent?.accept ||
            fallbackCopy.components.cookieConsent.accept}
          </button>
          <button className={`baseButton declineButton`} onClick={()=>handleCookieConsent(false)}>
            {localeCopy?.components?.cookieConsent?.decline ||
            fallbackCopy.components.cookieConsent.decline}
          </button>
        </div>
      </div>
    )
  }
}

//TODO: app has two styles, desktop + smallMobile, that aren't set up correctly to define desktop -> mobile, and are, of course, set as part of app state
//these get overwritten because the dvmkids/theme api sends these media queries as part of the theme as well
//so lets just use a custom css media filter here as this is really the only thing affected by it. its fine
const cookieMobile = `@media (max-width: 599px)`;

const StyledCC = styled((props: any) => <CookieConsent {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    zIndex: 10,
    position: "fixed",
    width: "100%",
    height: "120px",
    margin: "auto",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    border: "1px solid black",
    display: "flex",
    padding: "20px",
    justifyContent: "center",
    alignItems: "center",
    [cookieMobile]: {
      height: "150px"
    },
    '.buttonContainer': {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      [cookieMobile]: {
        gap: "16px"
      }
    },
    '.consentDesc': {
      fontFamily: theme.fonts.families,
      fontSize: "14px",
      marginRight: "24px",
      [cookieMobile]: {
        marginRight: "16px",
        fontSize: "13px"
      }
    },
    '.baseButton': {
      cursor: "pointer",
      fontFamily: theme.fonts.families,
      fontSize: "14px",
      width: "200px",
  
      height: "40px",
      backgroundColor: "black",
      color: "white",
      border: "unset",
      whiteSpace: "nowrap",
      [cookieMobile]: {
        width: "140px",
        height: "40px"
      }
    },
    '.declineButton': {
      backgroundColor: "white",
      color: "black",
      border: "1px solid black"
    },
  })}
`;

export default StyledCC;